import { useSnapshot } from "valtio"
import { AgmodalStore, contractsStore, loginStore } from "../state/CommonState"
import { taskStore } from "./task-store"
import Taskfiledisplay from "./task-file-display"
import FCLChargeClientViewv3 from "../enquiryv3/FCLChargeClientView-v3"
import AirChargesClientViewv3 from "../enquiryv3/AirChargesClientView-v3"
import LCLChargeClientViewv3 from "../enquiryv3/LCLChargeClientView-v3"
import { loader } from "../util/loader"
import MonApi from "../state/mongo-api"
import Taskapi from "./tasks-api"

export default function Approvalforloss(props) {
    useSnapshot(taskStore)
    useSnapshot(contractsStore) 
    let stage = taskStore.current.stage
    const save = async (approve)=>{
        loader.show()
        taskStore.current.approve = approve
        taskStore.current.stage = 2
        taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
        taskStore.setComplete()
        taskStore.setCustomerComplete()
        let u = {
            updatedOn:Date.now(),
            updatedBy:loginStore.email,
            status:"updated"
        }
        taskStore.current.updatelist.push(u)
        taskStore.current.updatelist.sort((a,b)=>{
            return b.updatedOn - a.updatedOn
        })
        await MonApi.replaceOne('Myactions', taskStore.current)
        Taskapi.sendActionAgragaTriggerEmail()
        loader.hide()
        if(AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()){
            AgmodalStore.pageVisible = false
            AgmodalStore.apiCall = true
            AgmodalStore.modalPage = "ViewEnquiryBooking-v3"
        }
        taskStore.triggerActionVisible = false
        taskStore.myActionVisible = false
    }
    return (<>
    {
        (stage!=undefined && stage==2)?<>
        <h1><strong>Status : {(taskStore.current.approve)?"Approved":"Rejected"}</strong></h1>
        </>:""
    }
    <h1><strong>Sell Charges</strong></h1>
    
            {
                (contractsStore.current.shipmentType.indexOf("FCL") >= 0)?<FCLChargeClientViewv3 dummyContract={contractsStore.current}/> :<>
                {
                (contractsStore.current.shipmentType.indexOf("Air") >= 0)?<AirChargesClientViewv3 dummyContract={contractsStore.current}/> :
                <LCLChargeClientViewv3 dummyContract={contractsStore.current}/> 
                }
                </>
            }
    <h1><strong>Cost Charges</strong></h1>
            {
                (contractsStore.current.shipmentType.indexOf("FCL") >= 0)?<FCLChargeClientViewv3 dummyContract={taskStore.current}/> :<>
                {
                (contractsStore.current.shipmentType.indexOf("Air") >= 0)?<AirChargesClientViewv3 dummyContract={taskStore.current}/> :
                <LCLChargeClientViewv3 dummyContract={taskStore.current}/> 
                }
                </>
            }
            <Taskfiledisplay notshow={true} validation={true}/>
            {
                (stage!=undefined && stage==1)?<>
                <button className="button islink" onClick={async (e) => {
                    await save(true)
        }}>Approve</button>
        <button className="button islink" onClick={async (e) => {
                    await save(false)
        }}>Reject</button>
                </>:""
            }
    </>)
}